import React from "react";
import { Box, Grid, IconButton, InputAdornment } from "@mui/material";

import Search from "../Search";
import crossIcon from "../../styles/svg/crossIcon.svg"
import newSearchIcon from "../../styles/svg/newSearchIcon.svg"
import { CustomTextField } from "../TextField";
import { useBoardSearchState } from "./hooks/useBoardSearchState";

function SearchBoard({ isBoardSearch, setSearchBar }) {
  const { handleChange, handleClear, inputValue } =
    useBoardSearchState(setSearchBar);

  return (
    <>
      {isBoardSearch ?
          <CustomTextField
            variant="standard"
            className="sidebar-search-board-input"
            onChange={handleChange}
            value={inputValue}
            // placeholder="Find Board"
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                  <img src={newSearchIcon} alt="search" width={18} height={18} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClear} size="small">
                    <img src={crossIcon} alt="clear" width={16} height={16} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoFocus
          />
        :
        <Grid item xs={5} className="">
          <div className="header-right">
            <Box mx={2} mb={2}>
              <Search
                searchText={inputValue}
                handleChange={handleChange}
                placeholder={"Find Board"}
              />
            </Box>
          </div>
        </Grid>
      }
    </>
  );
}

export default React.memo(SearchBoard);
